export default "__VITE_ASSET__fkA10sDt__"